module.exports = __webpack_public_path__ + "static/media/refund-apply.34e83697.svg";